import { AlertCircle, HelpCircle, RefreshCw } from 'lucide-react';
import { Button } from 'v5/design-system/Button';

export interface FormDialogErrorProps {
  error: Error;
  title?: string;
  description?: string;
  onRetry?: () => void;
  onContactSupport?: () => void;
  showSupportInfo?: boolean;
}

export const FormDialogError = ({
  error,
  title = 'Something Went Wrong',
  description,
  onRetry,
  onContactSupport,
  showSupportInfo = true
}: FormDialogErrorProps) => (
  <div className="pt-2 pb-6 px-4 text-center flex flex-col items-center">
    <div className="inline-flex items-center justify-center w-14 h-14 bg-rose-100 rounded-full shadow-sm mb-4 mt-2">
      <AlertCircle
        className="w-8 h-8 text-rose-600"
        style={{ filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.06))' }}
      />
    </div>
    <h3 className="text-xl font-semibold text-brand-900 mb-1">{title}</h3>
    <p className="text-base text-brand-700 max-w-180 mx-auto mb-5">
      {description ||
        error.message ||
        'An unexpected error occurred. Please try again.'}
    </p>
    <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full max-w-xs mx-auto mb-4">
      {onRetry && (
        <Button
          onClick={onRetry}
          variant="primary"
          size="md"
          className="w-full sm:w-auto"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Try Again
        </Button>
      )}
      {onContactSupport && (
        <Button
          onClick={onContactSupport}
          variant="secondary"
          size="md"
          className="w-full sm:w-auto"
        >
          <HelpCircle className="w-4 h-4 mr-2" />
          Contact Support
        </Button>
      )}
    </div>
    {showSupportInfo && (
      <div className="mt-2 p-3 bg-brand-50 rounded-lg border border-brand-100 w-full max-w-180 mx-auto">
        <p className="text-sm text-brand-500">
          If this problem persists, please check your connection or contact our
          support team.
        </p>
      </div>
    )}
  </div>
);
